import Live3TCWrapper from "../../components/live3/tc/Live3TCWrapper";
import { config3 } from "../../constant/initDrawing";
import { useSocket } from "../../helpers/socket";


const config = {
    ...config3,
    type: "tn",
    hlBG: "#A6ED8E",
    row_0: "#1B5A7A",
    subFixType: "minhngoc",
}

const Live3TCPage = () => {
    const { socket } = useSocket({ platform: `tn_minhngoc_website` });
    return <Live3TCWrapper socket={socket} config={config} />
}

export default Live3TCPage;